<template>
  <van-field v-bind="$attrs"
      v-model="scope.value"
      :rules="[
                        {
                          required: true,
                          message: $t('请输入验证码'),
                        },
                      ]"
      type="number"
  >
    <template #button>
      <van-count-down
          v-if="time > 0"
          :time="time"
          @change="changeTime"
      >
        <template #default="timeData">
                            <span class="block text-grey">{{
                                $t("在_s后发送", [timeData.seconds])
                              }}</span>
        </template>
      </van-count-down>
      <van-button
          v-else
          size="mini"
          type="primary"
          @click.stop="sendCode"
      >{{ $t("发送验证码") }}
      </van-button>
    </template>
  </van-field>
</template>
<script>
import {sendCode} from "@/api/sys/common";
import mixin_scope from "@/mixin/mixin_scope";
const isProd = process.env.NODE_ENV === 'production'

export default {
  name: 'validCode',
  mixins: [mixin_scope],
  props: {
    phone: {},
    email: {},
    sendType: {},
    params: { default(){return {}}},
  },
  data() {
    return {
      time: 0
    };
  },
  computed: {
    isEmail() {
      return "1" === this.paramMapAll["EMAIL_OPEN"];
    },
  },
  created() {
    this.time = parseInt(Cookies.get('Forget_Code_Countdown_Time'))
    if (!isProd) {
      Cookies.set('Forget_Code_Countdown_Time', 0)
    }
  },
  methods: {
    sendCode() {
      let account = this.isEmail ? this.email : this.phone
      if (!account) {
        this.$dialog.alert({
          message:
              this.isEmail ?
                  (this.$t('请输入') + this.$t('邮箱')) :
                  this.$t('请输入手机号码')
        })
        return
      }
      this.time = 60000
      Cookies.set('Forget_Code_Countdown_Time', 60000)
      sendCode({
        params:this.params,
        isEmail: this.isEmail,
        phone: account,
        sendType: this.sendType
      })
          .then(() => {
            this.$dialog.alert({
              message: this.$t('验证码发送成功')
            })
          })
          .catch(() => {
            this.time = 0
            Cookies.set('Forget_Code_Countdown_Time', 0)
          })
    },
    changeTime(timeData) {
      this.time = timeData.seconds * 1000 + timeData.milliseconds
      Cookies.set(
          'Forget_Code_Countdown_Time',
          timeData.seconds * 1000 + timeData.milliseconds
      )
    },
  }
};
</script>
